import { render, staticRenderFns } from "./DouleurNevromeDeMorton.vue?vue&type=template&id=a2b35c68&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports